// It is important to always search for usages before modifying / removing the key(s),
// as these are soft references and would often only break during runtime.
export default {
  errors: {
    unexpectedDefaultMessage:
      'An unexpected error has occurred, please try again.'
  },

  knowledgeBaseLinks: {
    communicationPreferenceAnchor:
      "<a href='http://help.getmobiz.com/en/articles/4929196-understanding-permissions' target='_blank'>View permissions guide</a>",
    communicationPreferenceLink:
      'http://help.getmobiz.com/en/articles/4929196-understanding-permissions',
    bulkContactUploadLink:
      'http://help.getmobiz.com/en/articles/4929152-uploading-contacts#h_d427bf9d6c',
    conditionalPersonalisationLink:
      'http://help.getmobiz.com/en/articles/5209757-conditional-personalization',
    creditsGetInTouchLink: 'http://help.getmobiz.com/en/',
    personalisationLink:
      'http://help.getmobiz.com/en/articles/5209757-personalization-and-defaults',
    composeSmsLink:
      'http://help.getmobiz.com/en/articles/5306744-composing-an-sms',
    smsSendingTimesLink:
      'http://help.getmobiz.com/en/articles/5306635-sms-sending-times',
    campaignTypesLink:
      'http://help.getmobiz.com/en/articles/5220421-campaign-objectives',
    doubleOptInLink:
      'http://help.getmobiz.com/en/articles/5387198-creating-growth-campaigns',
    zapierLink:
      'https://help.getmobiz.com/en/articles/5885644-integrating-mobiz-and-zapier',
    textToJoinKeywordsLink:
      'http://help.getmobiz.com/en/articles/5497009-creating-text-to-join-keywords',
    billingAndPricingLink:
      'http://help.getmobiz.com/en/articles/5688703-pricing-faq',
    helpCentreLink: 'http://help.getmobiz.com/en/',
    contactUploadGuidelineLink:
      'http://help.getmobiz.com/en/articles/4929152-how-to-import-contacts-into-mobiz',
    understandingContactPermissions:
      'http://help.getmobiz.com/en/articles/4929196-understanding-contact-permissions',
    understandingLists:
      'http://help.getmobiz.com/en/articles/5119675-creating-lists-and-assigning-contacts',
    imageResizeGuideLink:
      'http://help.getmobiz.com/en/articles/7882621-resizing-images-for-optimal-performance-in-mobiz',
    howToUseTheCodeElement:
      'https://help.getmobiz.com/en/articles/8548906-how-to-use-the-code-element',
    complianceQuietHours:
      'https://help.getmobiz.com/en/articles/5306635-text-message-compliance-quiet-hours',
    customDomain:
      'https://help.getmobiz.com/en/articles/6564860-how-to-connect-your-own-custom-domain-to-mobiz-aka-cname',
    numberLookups: '', //to be updated once completed,
    optOutImport:
      'https://help.getmobiz.com/en/articles/10441386-how-to-import-an-opt-out-list-on-mobiz',
    mmsFormat:
      'https://help.getmobiz.com/en/articles/10695997-best-practices-for-creating-an-mms',
    optOutImport:
      'https://help.getmobiz.com/en/articles/10441386-how-to-import-an-opt-out-list-on-mobiz',
    mmsFormat:
      'https://help.getmobiz.com/en/articles/10695997-best-practices-for-creating-an-mms'
  },

  contacts: {
    columnInfo: {
      communicationPreference:
        '@:knowledgeBaseLinks.communicationPreferenceAnchor'
    }
  },

  campaigns: {
    elements: {
      onlyOneButtonAllowed:
        'Only one button per campaign is allowed at this time'
    },
    sms: {
      singleSmsCharsAndCredits:
        'A standard SMS is 160 chars long and costs 1 credit each.',
      multipleSmsCharsAndCredits:
        'SMSes over 160 chars will cost 2 credits each.',
      personalizationFieldCharWeight:
        'Each personalization field used counts as 15 characters.',
      charCountIsApproximation:
        'The count displayed is an approximation; total credits required are calculated on the review step.',
      mmsInformation:
        'Sending an MMS uses more credits, you will be charged 3 credits for each message.',
      testSmsCostInformation:
        'A test message can use from 1 - 3 credits depending on length or type.'
    },
    designErrorDialog: {
      default: {
        approveName: 'Yes, ignore it',
        cancelName: 'No, go back',
        header: 'An error exists',
        body: 'There is an error on your template. Would you like to ignore it?'
      },
      formEmptyFields: {
        approveName: 'Delete form',
        cancelName: 'Select a field',
        header: 'Your form is incomplete.',
        body: 'Please select at least one field in order to complete your form.'
      }
    }
  },

  growthCampaigns: {
    socialMedia: {
      defaultTitle: 'Join our SMS channel for updates.',
      defaultDescription: `Follow this link and hit send to receive news and updates straight to your mobile.`
    }
  },

  tips: {
    confirmCompanyDetails:
      'Please confirm your company name and define your customer care contact number.',
    trialExpired:
      'Your free trial has expired. Please upgrade to use this functionality.',
    inactiveClient:
      'Your plan has expired. Please resubscribe to use this feature.',
    reachedContactLimit:
      'You have reached your contact limit. Please upgrade to add more contacts.',
    requiresEmailVerification:
      'Please verify your email address before proceeding.',
    requiresVerifiedPhoneNumber: 'You need a verified number to send.',
    addContactNotEnoughCredits: `You have insufficient credits to add contacts.`,
    t2jNoVerifiedPhoneNumber:
      'You need a verified number to enable this keyword.',
    t2jNotEnoughCredits: `Your credit balance is too low to enable this keyword.`,
    t2j0Credits: `You have insufficient credits.`,
    defineCustomerCareNumber:
      'Please confirm your company name and define your customer care contact number.'
  },

  clients: {
    subscription: {
      shopify: {
        requiresActiveConnection:
          'Please ensure you have an active Shopify connection before proceeding.'
      }
    }
  },

  adminOnly: {
    campaigns: {
      sms: {
        testSmsCostInformation:
          'As an admin user, note that sending a test SMS incurs no cost on the account.'
      }
    }
  }
};
